import * as types from './types';

const setCollapseWidget = (payload) => ({
  type: types.SET_IS_COLLAPSED,
  payload,
});

const showGuidingModal = (payload) => ({
  type: types.UI_SHOW_GUIDING_MODAL,
  payload,
});

export const handleShowGuidingModal = (open) => {
  return (dispatch) => {
    dispatch(showGuidingModal({ open }));
  };
};

export const handleCollapseCard = (payload) => {
  return (dispatch) => {
    dispatch(setCollapseWidget(payload));
  };
};
